import {Directive, HostListener, NgModule} from "@angular/core";

@Directive({
  selector: "[prevent-autocompleted-error]"
})
export class PreventAutoCompletedErrorDirective {
  @HostListener("keyup", ["$event"])
  public onKeyUp(event: any): void {
    switch (event.key) {
        case "ArrowLeft":
            event.preventDefault();
            event.stopPropagation();
            break;
        case "ArrowRight":
            event.preventDefault();
            event.stopPropagation();
            break;
        case "ArrowUp":
            event.preventDefault();
            event.stopPropagation();
            break;
        case "ArrowDown":
            event.preventDefault();
            event.stopPropagation();
            break;
    }
  }
}
@NgModule({
    imports: [
    ],
    declarations: [
        PreventAutoCompletedErrorDirective,
    ],
    exports: [
        PreventAutoCompletedErrorDirective,
    ]
})

export class PreventAutoCompletedErrorModule {

}